import { Route, Routes } from "react-router-dom";

import { RequireAuth } from "@/auth/RequireAuth";
import { ChatPage } from "@/features/chat/ChatPage";
import { AuditPage } from "@/features/admin/AuditPage";
import { DataSourcesPage } from "@/features/admin/DataSourcesPage";
import { UsagePage } from "@/features/admin/UsagePage";
import { Shell } from "@/app/Shell";

export function App() {
  return (
    <Shell>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <ChatPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/usage"
          element={
            <RequireAuth>
              <UsagePage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/audit"
          element={
            <RequireAuth>
              <AuditPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/data-sources"
          element={
            <RequireAuth>
              <DataSourcesPage />
            </RequireAuth>
          }
        />
      </Routes>
    </Shell>
  );
}
